import React from "react";
import ViewsLoading from "theme/views/ViewsLoading";
import loadable from "@loadable/component";

const options = {
    fallback: <ViewsLoading />,
};

export default {
    default: loadable(() => import("./Default"), options),
    landing_page: loadable(() => import("./LandingPage"), options),
};
